export default __webpack_public_path__ + "7fdb35cff619a6848d922eb30faa2438.png";